import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCheckCallScheduleLookup extends Layout {
    sourceCheckCallSchedLookup: DataSource;
    tableCheckCallSchedules: Table;
}
